import { useState } from 'react';
import { HoldingCommonData, HoldingsSortBy } from '../../types';

export enum HoldingsType {
  Live = 'live',
  Realised = 'realised',
}

export type HoldingsSortKey = Extract<
  keyof HoldingCommonData,
  'shareClassName' | 'assetName'
>;

export const useHoldingsSortState = () => {
  const [state, setState] = useState<{
    [HoldingsType.Live]: HoldingsSortBy;
    [HoldingsType.Realised]: HoldingsSortBy;
  }>({
    [HoldingsType.Live]: HoldingsSortBy.ByClass,
    [HoldingsType.Realised]: HoldingsSortBy.ByClass,
  });

  const setSortState = (update: Partial<typeof state>) => {
    setState((prev) => ({ ...prev, ...update }));
  };

  return {
    setSortState,
    state,
  };
};
